module.exports = __webpack_public_path__ + "static/img/new_1.b50735b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_1.png
// module id = tL4C
// module chunks = 0